import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { NglModule} from 'ng-lightning';

import { RvrsSearchPointModalComponent } from './rvrs-search-point-modal.component';
import { ConfirmDialogModule } from '../../../../../common/component/confirm-dialog/confirm-dialog.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NglModule,
    InputsModule,
    ConfirmDialogModule
  ],
  declarations: [RvrsSearchPointModalComponent],
  exports: [RvrsSearchPointModalComponent],
  schemas:[ CUSTOM_ELEMENTS_SCHEMA ]
})
export class RvrsSearchPointModal { }
